import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//API
import ItemService from "../../../../services/supplier_appCommonService";
import ItemServiceC1 from "../../../../services/customer_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatDate } from "../../../../common/Validations";
import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import toast from "react-hot-toast";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import CustomerConstants from "../../../../common/CustomerConstants";
import QualityCheckModal from "./QualityCheckModal";

const QualityCheckCreationV5 = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "");

  // let grn_data = useSelector(
  //   (state) => state?.purchasing?.goods_received_note?.data
  // ); // User Details from Store

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  let grnNumber = useSelector(
    (state) => state?.purchasing?.goods_received_note?.grnNumber,
  ); // User Details from Store

  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO,
  ); // workflowPO from Store

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getHeaderData, setHeaderData] = useState({
    grnStatusHeader: "",
  });

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const [getItemHeaderTextData, setItemHeaderTextData] = useState("");
  const [getItemHeaderTextColumns, setItemHeaderTextColumns] = useState("");
  const [getItemHeaderTextModalTitle, setItemHeaderTextModalTitle] =
    useState(false);
  const [getItemTextModalShow, setItemTextModalShow] = useState(false);

  const [formInputs, setFormInputs] = useState({
    email: "",
    firstName: "",
    lastName: "",
    contactNumber: "",
    companyName: "",
    createdBy: userData?.userId,
    _id: "",
    // qualityCheckNr:"",
    grnNumber: "",
    grnNr: "",
  });

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  // Workflow
  const [modalShow, setModalShow] = useState(false);
  const [getAction, setAction] = useState("");

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");
  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const itemHeaderColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // OnClick on ITEM Text Data
  // eslint-disable-next-line
  const itemTextShowModal = (itemTextData) => {
    setItemHeaderTextData(itemTextData);
    setItemHeaderTextColumns(itemHeaderColInfo);
    setItemHeaderTextModalTitle("Item Text Details");
    setItemTextModalShow(true);
  };
  const itemTextHideModal = () => {
    setItemTextModalShow(false);
  };
  const [showQCModal, setShowQCModal] = useState(false);
  const [qcType, setQcType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  // eslint-disable-next-line
  const [qcData, setQcData] = useState({});

  // const handleQCCheck = (type, row) => {
  //   setQcType(type);
  //   setSelectedRow(row); // no saved data here
  //   setShowQCModal(true);
  // };
const handleQCCheck = (type, row) => {
  const updatedData = data.map((item) => {
    if (item.grnItemNr === row.grnItemNr) {
      if (type === "PHYSICAL") {
        return {
          ...item,
          hasPhysicalQC: !item.hasPhysicalQC,
        };
      } else {
        return {
          ...item,
          hasSpecificationQC: !item.hasSpecificationQC,
        };
      }
    }
    return item;
  });

  setData(updatedData);

  setFormInputs((prev) => ({
    ...prev,
    items: updatedData,
  }));

  // 🔥 Get updated row
  const updatedRow = updatedData.find(
    (item) => item.grnItemNr === row.grnItemNr
  );

  // 🔥 Merge saved QC like handleViewQC
  const savedQC = qualityCheckItems.find(
    (item) =>
      item.grnItemNr === row.grnItemNr &&
      item.materialCode === row.materialCode &&
      item.qcType === type
  );

  setQcType(type);

  setSelectedRow({
    ...updatedRow,
    ...(savedQC || {}),
  });

  setShowQCModal(true);
};

  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  const qualityChecks = qualityCheckItems.map((qc) => ({
    grnItemNr: qc.grnItemNr,
    materialCode: qc.materialCode,
    materialDescription: qc.materialDescription,
    grnQuantity: qc.grnQuantity,
    qcType: qc.qcType,

    packagingCondition: qc.packagingCondition || "",
    physicalDamage: qc.physicalDamage || "",
    quantityVerified: qc.quantityVerified || "",
    inspectionRemarks: qc.inspectionRemarks || "",

    modelMatch: qc.modelMatch || "",
    brandMatch: qc.brandMatch || "",
    sizeGradeMatch: qc.sizeGradeMatch || "",
    technicalParamsOk: qc.technicalParamsOk || "",
  }));

  const getGodownCode = (value) => {
    if (value === "Rent") return "RE";
    if (value === "Sale") return "SL";
    return "NA";
  };
  const calculateMonthlyRoiAmount = (unitPrice, roiMonths) => {
    if (!unitPrice || !roiMonths) return 0;
    return Number((unitPrice / roiMonths).toFixed(2));
  };
  // eslint-disable-next-line
  const handleCreateBarcode = async (row) => {
    try {
      const selectedItem = data.find(
        (item) => item.grnItemNr === row.grnItemNr,
      );

      if (!selectedItem) {
        toast.error("Item data not found");
        return;
      }
      const rowQualityChecks = qualityChecks.filter(
        (qc) => qc.grnItemNr === row.grnItemNr,
      );
      const godownCode = getGodownCode(row.storageLocation);

      const roiCodeMonths = 36; //  fixed as per your logic
      const unitPrice = Number(row.unitPrice) || 0;

      // const itemsExtraFields =
      // {
      //   salePrice:row.salePrice,

      // }
      const itemsExtraFields = {
        materialAttachments: row.materialAttachments,
        materialImage: row.materialImage,
        materialCode: row.materialCode,
        materialDescription: row.materialDescription,
        materialGroup: row.materialGroup,
        average: row.average,
        quntity: row.quntity,
        pieceMeasure: row.pieceMeasure,
        unit: row.unit,
        unitWeight: row.unitWeight,
        unitPrice: row.unitPrice,
        unitWeightModifier: row.unitWeightModifier,
        unitPriceModifier: row.unitPriceModifier,
        surfacePaintArea: row.surfacePaintArea,
        remarks: row.remarks,
        weightPice: row.weightPice,
        weightTotal: row.weightTotal,
        bookPrice: row.bookPrice,
        bookTotalPrice: row.bookTotalPrice,
        topSelling: row.topSelling,
        companyCode: row.companyCode,
        companyCodeCode: row.companyCodeCode,
        companyCodeDesc: row.companyCodeDesc,
        materialSubCategory: row.materialSubCategory,
        hsnCode: row.hsnCode,
        location: row.location,
        purchaseQuantity: row.purchaseQuantity,
        unitCode: row.unitCode,
        unitDesc: row.unitDesc,
        targetCategory: row.targetCategory,
        criticalProduct: row.criticalProduct,
        brand: row.brand,
        storageLocation: row.storageLocation,
        storageLocationCode: row.storageLocationCode,
        storageLocationDesc: row.storageLocationDesc,
        discarded: row.discarded,
        warranty: row.warranty,
        mrPrice: row.mrPrice,
        taxCode: row.taxCode,
        cog: row.cog,
        salePrice: row.salePrice,
        rentPerDayPrice: row.rentPerDayPrice,
        rent7DaysPrice: row.rent7DaysPrice,
        rent15DaysPrice: row.rent15DaysPrice,
        rent30DaysPrice: row.rent30DaysPrice,
        securityAmt: row.securityAmt,
        lockInPeriod: row.lockInPeriod,
        activeInactive: row.activeInactive,
        orderPriceUnit: row.orderPriceUnit,
        orderUnitOfMeasure: row.orderUnitOfMeasure,
        uOM: row.uOM,
      };

      const rentExtraFields =
        godownCode === "RE"
          ? {
              // assetActiveInactive: true,
              // roiCodeMonths: 36,
              assetActiveInactive: true,
              roiCodeMonths,
              monthlyRoiAmount: calculateMonthlyRoiAmount(
                unitPrice,
                roiCodeMonths,
              ),
            }
          : {};
      const saleExtraFields =
        godownCode === "SL"
          ? {
              assetActiveInactive: true,
              // roiCodeMonths: 36,
            }
          : {};

      //  Payload
      const payload = {
        data: {
          CreatedTime: 0,
          assambledBrcode: "NULL",
          barcodeStatus: 0,
          chno: "NULL",
          companyCodeDesc: row.companyCodeDesc || null,
          createdOn: new Date().toISOString().split("T")[0],

          disassambledBrcode: "NULL",
          dissambleto: "NULL",
          entryType: null,
          erfNr: null,
          godown: row.storageLocation,
          godownCode: godownCode,
          ...rentExtraFields,
          ...saleExtraFields,
          ...itemsExtraFields,

          godown1: null,
          gstCode: null,

          iphslrPrice: row.iphslrPrice,
          mrPrice: row.mrPrice,
          pcdlrPrice: row.pcdlrPrice,
          unitPrice: row.unitPrice,
          storageLocation: row.storageLocation,

          materialCode: row.materialCode,
          materialDescription: row.materialDescription,
          materialItemNr: row.materialItemNr,

          purchaseQuantity: Number(row.grnQuantity),
          purchasingCategorytype: "Trade",
          purchasingDocumentNr: row.purchasingDocumentNr,
          purchasingtype: "Purchase",

          rcvby: getHeaderData?.createdByName || "SYSTEM",
          srno: row.grnItemNr,

          status: "NULL",
          stockadj: "NULL",
          supplierLotno: "NULL",

          //  QC DETAILS SENT TO API
          qualityCheckDetails: rowQualityChecks,
        },
      };

      const res = await ItemService.addMaterialBarcodeItem(payload);

      if (res?.status === 200) {
        toast.success("Barcode created successfully");
      } else {
        toast.error(res?.message || "Barcode creation failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) =>
        item.grnItemNr === row.grnItemNr &&
        item.materialCode === row.materialCode &&
        item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}), //  THIS IS THE FIX
    });
    setShowQCModal(true);
  };

  const columns = [
    {
      name: "GRN Item Nr",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "PO Item/No",
      selector: (row) => row.purchasingDocumentItemNr,
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium"> {row.purchasingDocumentItemNr} </p>
          <p className="p-0 m-0"> {row.purchasingDocumentNr} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "180px",
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialDescription,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.materialDescription} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "UOM",
      selector: (row) => row.unit ?? row.orderUnitOfMeasure,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Qty",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity,
      sortable: true,
      width: "150px",
    },
    {
      name: "Quality Check",
      width: "240px",
      cell: (row) => (
        <div className="d-flex gap-3 ms-1">
          <div>
            <input
              type="checkbox"
              checked={row.hasPhysicalQC}
              onChange={() => handleQCCheck("PHYSICAL", row)}
            />
            <label
              className="ms-1 fw-bold"
              onClick={() => handleViewQC("PHYSICAL", row)}
            >
              Physical
            </label>
          </div>

          <div>
            <input
              type="checkbox"
              checked={row.hasSpecificationQC}
              onChange={() => handleQCCheck("SPECIFICATION", row)}
            />
            <label
              className="ms-1 fw-bold"
              onClick={() => handleViewQC("SPECIFICATION", row)}
            >
              Specification
            </label>
          </div>
        </div>
      ),
    },
    //       {
    //   name: "Barcode",
    //   width: "150px",
    //   cell: (row) => (
    //     <button
    //       className="btn btn-sm btn-primary"
    //       onClick={() => handleCreateBarcode(row)}
    //     >
    //       Create Barcode
    //     </button>
    //   ),
    // },
    {
      name: "Balance Qty",
      selector: (row) => row.grnBalancePurchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocation,
      sortable: true,
      width: "180px",
      cell: (row) => {
        const value = row.storageLocation;

        const color =
          value === "Rent" ? "red" : value === "Sale" ? "green" : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{value}</span>;
      },
    },

    {
      name: "ShortageLocation",
      selector: (row) => row.storagePlace,
      sortable: true,
      width: "200px",
    },
  ];

  const loadInitialPageData = async () => {
    setLoading(true);
    if (grnNumber) {
      let obj = {
        documentNumber: grnNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemService.getGrnDatail(obj).then((item) => {
        if (item?.status === 200) {
          setHeaderData(item?.data[0]);
          let itemData = item?.data[0]?.items;
          // setFormInputs(...item?.data[0]);
          setFormInputs({
            ...item?.data[0],
            createdBy: userData?.userId,
          });

          setData(itemData);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      // window.history.back();
    }
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grnNumber]);

  // eslint-disable-next-line
  const [tableData, setTableData] = useState([]);

  const handleSaveQualityCheck = (qcPayload) => {
    setQualityCheckItems((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.grnItemNr === qcPayload.grnItemNr &&
          item.qcType === qcPayload.qcType,
      );

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = qcPayload;
        return updated;
      }
      return [...prev, qcPayload];
    });

    setTableData((prevRows) =>
      prevRows.map((row) =>
        row.grnItemNr === qcPayload.grnItemNr
          ? {
              ...row,
              hasPhysicalQC:
                qcPayload.qcType === "PHYSICAL" ? true : row.hasPhysicalQC,
              hasSpecificationQC:
                qcPayload.qcType === "SPECIFICATION"
                  ? true
                  : row.hasSpecificationQC,
            }
          : row,
      ),
    );
  };

  const handleSave = async () => {
    const toastId = toast.loading("Saving...", {
      position: "top-right",
    });

    try {

    const invalidItem = formInputs.items.find(
      (item) => !item.hasPhysicalQC || !item.hasSpecificationQC
    );

    if (invalidItem) {
      toast.dismiss(toastId);

      toast.error(
        `QC not completed for Item No: ${invalidItem.grnItemNr}`,
        { position: "top-right" }
      );

      return; 
    }
      const grnPayload = {
        ...formInputs,

        vendorCode: getHeaderData.vendorCode,
        vendorName: getHeaderData.vendorName,
        deliveredValue: getHeaderData.deliveredValue,
        deliveredStatus: getHeaderData.deliveredStatus,
        invoicedValue: getHeaderData.invoicedValue,
        invoicedStatus: getHeaderData.invoicedStatus,
        paidValue: getHeaderData.paidValue,
        vendorInvoiceCurrency: getHeaderData.currencyCode,
        purchasingDocumentDate: getHeaderData.purchasingDocumentDate,
        incoTerms: getHeaderData.incoTerms,
        paymentTerms: getHeaderData.paymentTerms,
        purchasingDocumentValue: getHeaderData.purchasingDocumentValue,
        currency: getHeaderData.currency,
        currencyCode: getHeaderData.currencyCode,
        // qualityChecker: formInputs.createdBy,
        qualityCheckNr: formInputs.qualityCheckNr,
      };

      const qualityChecks = qualityCheckItems.map((qc) => ({
        grnItemNr: qc.grnItemNr,
        materialCode: qc.materialCode,
        materialDescription: qc.materialDescription,
        grnQuantity: qc.grnQuantity,
        qcType: qc.qcType,

        packagingCondition: qc.packagingCondition || "",
        physicalDamage: qc.physicalDamage || "",
        quantityVerified: qc.quantityVerified || "",
        inspectionRemarks: qc.inspectionRemarks || "",

        modelMatch: qc.modelMatch || "",
        brandMatch: qc.brandMatch || "",
        sizeGradeMatch: qc.sizeGradeMatch || "",
        technicalParamsOk: qc.technicalParamsOk || "",
      }));

      const finalPayload = {
        ...grnPayload,
        qualityChecks,
      };

      const response = await ItemServiceC1.addQualityCheck({
        data: finalPayload, //  backend-required format
      });

      if (response?.status === 200) {
        toast.success("Saved Successfully", {
          position: "top-right",
        });
        navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_LIST_MR);
      } else {
        toast.error(response?.message || "Please try again", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Something went wrong", {
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const navigateToWorkflow = () => {
    // window.history.back();
    navigate(
      CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GOODS_RECEIVED_NOTE,
    );
  };

  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };

  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    obj.data = {};
    let newObj = { ...bodyObj, ...obj };

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      if (item?.status === 200) {
        successModalData.successMsg =
          getAction === "Approve"
            ? "Approved Successfully !!"
            : "Rejected Successfully !!";
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Quality Details :
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {grnNumber}
              </span>
              <span>
                {getHeaderData?.grnStatusHeader === "GRN Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader ===
                  "Pending for Approval" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "GRN Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Invoice Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "GRN Rejected" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Posted" ? (
                  <span className="bg-table-status bg-table-info-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Invoice Created" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Approve" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : (
                  getHeaderData.grnStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Quality Information </p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={8} lg={8} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
            </Row>

            {/* grn details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Quality Details</span>
                      {/*  <span className="subHeaderTitle">
                        RFQ Header Information
                      </span> */}
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="GRN Number"
                          name="grnNr"
                          id="grnNr"
                          value={formInputs.grnNr}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PO Number"
                          name="purchasingDocumentNr"
                          id="purchasingDocumentNr"
                          value={formInputs.purchasingDocumentNr}
                          // //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivered On"
                          name="createdAt"
                          id="createdAt"
                          value={formatDate(formInputs.createdAt)}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Quality Check Created On"
                          name="createdAt"
                          id="createdAt"
                          value={formatDate(formInputs.createdAt)}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivery Remarks"
                          name="grnRemark"
                          id="grnRemark"
                          value={formInputs.grnRemark}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status "
                          name="grnStatus"
                          placeholder=""
                          value={formInputs.grnStatus}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Goods Receiver"
                          name="generatedBy"
                          id="generatedBy"
                          value={formInputs.generatedBy}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PO Value (INR)"
                          name="purchasingDocumentValue"
                          id="purchasingDocumentValue"
                          value={formInputs.purchasingDocumentValue}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Quality Checker"
                          name="createdBy"
                          id="createdBy"
                          value={formInputs.createdBy}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Line Items 2*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QD</span>
                    </Col>
                    <Col xs={12} md={6} lg={7}>
                      <span className="headerTitle">Quality Details</span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}

                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={columns}
                          data={data}
                          progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* GRN Attachments 3*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GA</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">GRN Attachments</span>
                      {/*  <span className="subHeaderTitle">
                        RFQ Header Information
                      </span> */}
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                      >
                        <div className="d-flex flex-column ">
                          <p className="fw-medium m-0 text-nowrap">
                            Shipping Documents
                          </p>

                          {(formInputs?.shippingDocuments && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.shippingDocuments)
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                      >
                        <div className="d-flex flex-column ">
                          <p className="fw-medium m-0 text-nowrap">
                            Other Attachments
                          </p>

                          {(formInputs?.otherAttachments && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.otherAttachments)
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* buttons */}
          <div className="pageFooter mb-2">
            <Row className="rowDirection">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btn w-full"
                  onClick={handleSave}
                  // disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={getItemTextModalShow}
        onHide={() => itemTextHideModal()}
        columns={getItemHeaderTextColumns}
        data={getItemHeaderTextData}
        title={getItemHeaderTextModalTitle}
      />

      <ApproveRemarksModal
        show={modalShow}
        onHide={() => hideModal()}
        onvaluechange={handleValueChange}
      />

      {/* Success Modal Workflow */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <QualityCheckModal
        show={showQCModal}
        onHide={() => setShowQCModal(false)}
        qcType={qcType}
        rowData={selectedRow}
        viewOnly={true} // NEW PROP
        onSaveQualityCheck={handleSaveQualityCheck}
      />
    </main>
  );
};

export default QualityCheckCreationV5;
